import {
  IPublicClientApplication,
  PublicClientApplication,
  BrowserCacheLocation,
  InteractionType,
  PopupRequest,
} from '@azure/msal-browser';
import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';

import { ROUTES_MAP } from '@config/routes-config';
import { fetchAzureConfig } from './azure-handler';

/**
 * OIDC scopes for Azure interactive login.
 * Backend validates the returned id_token via /api/public/authenticate/microsoft.
 * (Same outcome as the old msal@0.2 popup default that returned an id_token.)
 */
export const AZURE_LOGIN_REQUEST: PopupRequest = {
  scopes: ['openid', 'profile'],
};

export function msalInstanceFactory(): IPublicClientApplication {
  const azureConfig = fetchAzureConfig();

  return new PublicClientApplication({
    auth: {
      clientId: azureConfig.clientID,
      authority: azureConfig.loginUrl,
      redirectUri: `${window.location.origin}/${ROUTES_MAP.login}`,
      postLogoutRedirectUri: `${window.location.origin}/${ROUTES_MAP.login}`,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
  });
}

export function msalGuardConfigFactory(): MsalGuardConfiguration {
  // Guard is not used by the app; required by MsalModule.forRoot.
  return {
    interactionType: InteractionType.Popup,
    authRequest: AZURE_LOGIN_REQUEST,
  };
}

export function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  // Interceptor is not used (API auth is the backend JWT cookie).
  return {
    interactionType: InteractionType.Popup,
    protectedResourceMap: new Map(),
  };
}
